<template>
  <div class="base-login">
      <section class="box-login">
        <article class="box-login__right-box">
          <div class="form-login-meet">
            <div class="img-login">
              <img src="../assets/img/v4.0/logo-friendlyPos.png">
            </div>
            <h1 class="title-one">¡Hola</h1>
            <h1 class="title-two">Bienvenido!</h1>
            <input type="email" name="email" v-model="form.username" placeholder="Correo Eletrónico" class="form-meet"
                   required>
            <input type="password" name="pswd" v-model="form.password" placeholder="Contraseña" class="form-meet"
                   required>
            <small class="alert alert-danger" v-if="errors.email">{{errors.email}}</small>
            <br>
            <small class="alert alert-danger" v-if="errors.password">{{errors.password}}</small>
            <button @click="send" class="btn-meet">Iniciar Sesión</button>
            <p class="pull-right recover-pass-text"><a href="#">Recuperar Contraseña</a></p>
          </div>
          <footer class="footerSection">
            <div class="footerSection__img">
              <img src="../assets/img/products-login.png"  >
            </div>
            <div class="footerSection__text">
              <p> <a href="http://sistemasamigableslatam.com" target="_blank" class="">Copyrights <span class="fa fa-copyright "></span>  All Rights Reserved. Powered by Sistemas
                Amigables Latinoamérica S.A.</a>
              </p>
              <a class="" href="mailto:info@sistemasamigableslatam.com" target="_blank">Más información: info@sistemasamigableslatam.com</a>
            </div>
          </footer>
        </article>
        <article class="content-carousel">
          <div class="ibox-content ">
            <div id="carouselExampleIndicators" class="carousel slide" data-ride="carousel">
              <ol class="carousel-indicators">
                <li data-target="#carouselExampleIndicators" data-slide-to="0" class="active"></li>
                <li data-target="#carouselExampleIndicators" data-slide-to="1"></li>
                <li data-target="#carouselExampleIndicators" data-slide-to="2"></li>
              </ol>
              <div class="carousel-inner">
                <div class="carousel-item active">
                  <img class="d-block w-100 responsive" src="../assets/img/carousel/1.jpg" alt="First slide">
                </div>
                <div class="carousel-item">
                  <img class="d-block w-100" src="../assets/img/carousel/2.jpg" alt="Second slide">
                </div>
                <div class="carousel-item">
                  <img class="d-block w-100" src="../assets/img/carousel/3.jpg" alt="Third slide">
                </div>
              </div>
              <a class="carousel-control-prev" href="#carouselExampleIndicators" role="button" data-slide="prev">
                <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                <span class="sr-only">Previous</span>
              </a>
              <a class="carousel-control-next" href="#carouselExampleIndicators" role="button" data-slide="next">
                <span class="carousel-control-next-icon" aria-hidden="true"></span>
                <span class="sr-only">Next</span>
              </a>
            </div>
          </div>
        </article>
      </section>

  </div>
</template>
<script>
export default {

    name: "login",
    components: {},
    props: {
      msg: String
    },
    data(){
      return {
      user: '',
      form: {
        username: '',
        password: '',
        type_menu: 'ff'
      },
      errors:{
        username:'',
        password:'',
      }
    }},
    computed: {

    },
    methods: {
      async send() {
        try {
          await this.$store.dispatch('sendLogin', this.form).then(resp=>{
            if(resp){
             
              return this.$router.push({ path: '/' });
            }
          })
        } catch (error) {
          this.errors.username = error.message;
        }
      }
    }
  };
</script>
<style src="../assets/scss/login.scss"  lang="scss" scoped>

 .base-login{

  width: 70%;
 }
</style>
